import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledText = styled.span`
    ${mixins.setFontVariant("captionTitle", colorsPalettes.carbon["300"])};
    line-height: 16px;
`;

export const StyledDDHeader = styled.div`
    align-items: center;
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    display: flex;
    justify-content: space-between;
    padding: 10px 48px 9px 16px;
`;
